import { connect } from 'react-redux';

import { SellerProperties } from '../../store/seller/seller-properties';

import { FormattedCurrency } from './index';

type OwnProps = {
  currencyCode?: string;
  value: number;
  [key: string]: unknown;
};

const mapStateToProps = (state: object, { currencyCode, ...rest }: OwnProps) => {
  const { defaultCurrencyCode } = new SellerProperties({ state });

  return {
    currencyCode: currencyCode ?? defaultCurrencyCode,
    ...rest,
  };
};

export const FormattedCurrencyContainer = connect(mapStateToProps)(FormattedCurrency);
